export default __webpack_public_path__ + "static/media/img-7.c1d24290.jpg";